/**
 * WindowEditor - Component for editing window properties in Manual J room data
 */

import React from 'react';
import { Select, NumberInput } from '../ui/Input';
import { Button } from '../ui/Button';
import {
  WINDOW_TYPES,
  WINDOW_FRAME_TYPES,
  DIRECTIONS,
  SHADING_OPTIONS,
} from '../../constants/manualJOptions';

export default function WindowEditor({ window, onUpdate, onDelete, index }) {
  return (
    <div className="window-editor" style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>Window {index + 1}</span>
        <Button
          variant="ghost"
          size="small"
          onClick={onDelete}
          style={styles.deleteBtn}
        >
          Delete
        </Button>
      </div>

      <div style={styles.row}>
        <NumberInput
          label="Width (in)"
          value={window.width}
          onChange={(width) => onUpdate({ ...window, width: parseInt(width) || 0 })}
          min={6}
          max={120}
          style={styles.smallInput}
        />
        <NumberInput
          label="Height (in)"
          value={window.height}
          onChange={(height) => onUpdate({ ...window, height: parseInt(height) || 0 })}
          min={6}
          max={120}
          style={styles.smallInput}
        />
      </div>

      <div style={styles.row}>
        <Select
          label="Window Type"
          value={window.type}
          onChange={(type) => onUpdate({ ...window, type })}
          options={WINDOW_TYPES}
          style={styles.select}
        />
      </div>

      <div style={styles.row}>
        <Select
          label="Frame"
          value={window.frame}
          onChange={(frame) => onUpdate({ ...window, frame })}
          options={WINDOW_FRAME_TYPES}
          style={styles.select}
        />
      </div>

      <div style={styles.row}>
        <Select
          label="Facing"
          value={window.facing}
          onChange={(facing) => onUpdate({ ...window, facing })}
          options={DIRECTIONS}
          style={styles.smallSelect}
        />
        <Select
          label="Shading"
          value={window.shading}
          onChange={(shading) => onUpdate({ ...window, shading })}
          options={SHADING_OPTIONS}
          style={styles.select}
        />
      </div>
    </div>
  );
}

const styles = {
  container: {
    background: 'rgba(255,255,255,0.05)',
    borderRadius: '6px',
    padding: '10px',
    marginBottom: '8px',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#e0e0e0',
  },
  deleteBtn: {
    color: '#ff6b6b',
    fontSize: '11px',
    padding: '2px 8px',
  },
  row: {
    display: 'flex',
    gap: '8px',
    marginBottom: '6px',
  },
  smallInput: {
    flex: 1,
  },
  select: {
    flex: 1,
  },
  smallSelect: {
    width: '70px',
    flex: 'none',
  },
};
